export const toMoneyString = ({
    value,
    autoFraction = true,
}: {
    value: Maybe<string | number>
    autoFraction?: boolean
}) => {
    let newValue = ''
    if (!isNumberDecimal(value)) return newValue

    const removeSpaces = value!.toString().replace(/\s/g, '')
    const isHasFractions =
        ~removeSpaces.indexOf(',') || ~removeSpaces.indexOf('.')
    const withFractions = parseFloat(removeSpaces.replace(',', '.'))
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',')

    if (autoFraction || isHasFractions) {
        newValue = withFractions
    } else {
        newValue = parseInt(removeSpaces, 10)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }

    return newValue
}

export const isNumberDecimal = (value: Maybe<string | number>) =>
    (Boolean(value) && !isNaN(parseFloat(value!.toString()))) || value === 0
